import { render, staticRenderFns } from "./textLeft.vue?vue&type=template&id=8098c636&scoped=true&"
import script from "./textLeft.vue?vue&type=script&lang=js&"
export * from "./textLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8098c636",
  null
  
)

export default component.exports